import script from "./StatementSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementSheet.vue?vue&type=script&setup=true&lang=js"

import "./StatementSheet.vue?vue&type=style&index=0&id=2fefa423&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fefa423"]])

export default __exports__